(function () {
  'use strict';

  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function getGallery(element) {
    return (
      element?.closest('media-gallery') ||
      document.querySelector('media-gallery')
    );
  }

  function filterGallery(color, gallery) {
    if (!gallery || !color) return;

    const selectedColor = normalize(color);

    const slides = gallery.querySelectorAll(
      '.product__media-list .product__media-item'
    );

    const thumbnails = gallery.querySelectorAll(
      '.thumbnail-list__item'
    );

    let firstVisibleSlide = null;
    let visibleCount = 0;

    /*
     * MAIN GALLERY
     */
    slides.forEach(function (slide) {
      const mediaColor = normalize(
        slide.dataset.mediaColor
      );

      const shouldShow =
        mediaColor === selectedColor;

      slide.hidden = !shouldShow;

      if (shouldShow) {
        visibleCount++;

        if (!firstVisibleSlide) {
          firstVisibleSlide = slide;
        }
      }
    });

    /*
     * THUMBNAILS
     */
    thumbnails.forEach(function (thumbnail) {
      const targetId = thumbnail.dataset.target;

      const slide = gallery.querySelector(
        '[data-media-id="' + targetId + '"]'
      );

      if (!slide) {
        thumbnail.hidden = true;
        return;
      }

      thumbnail.hidden = slide.hidden;
    });

    /*
     * MAKE FIRST MATCHING IMAGE ACTIVE
     */
    if (firstVisibleSlide) {
  const currentActiveSlide =
    gallery.querySelector(
      '.product__media-item.is-active:not([hidden])'
    );

  if (!currentActiveSlide) {
    firstVisibleSlide.classList.add('is-active');

    const firstMediaId =
      firstVisibleSlide.dataset.mediaId;

    thumbnails.forEach(function (thumbnail) {
      const isActive =
        thumbnail.dataset.target === firstMediaId;

      if (isActive) {
        thumbnail.setAttribute(
          'aria-current',
          'true'
        );
      } else {
        thumbnail.removeAttribute(
          'aria-current'
        );
      }
    });
  }
}

    /*
     * UPDATE GALLERY COUNTER
     */
    const counter = gallery.querySelector(
      '.slider-counter--total'
    );

    if (counter) {
      counter.textContent = visibleCount;
    }

    /*
     * RESET SLIDER POSITION
     */
    const slider = gallery.querySelector(
      '.product__media-list'
    );

    if (slider && firstVisibleSlide) {
      slider.scrollTo({
        left: firstVisibleSlide.offsetLeft,
        behavior: 'instant'
      });
    }

    console.log(
      '[gallery-sync] Gallery filtered:',
      color,
      'Visible images:',
      visibleCount
    );
  }

  /*
   * DETECT SELECTED COLOR FROM VARIANT SELECTOR
   */
  function getSelectedColor(productInfo) {
    if (!productInfo) return '';

    const variantSelects =
      productInfo.querySelector('variant-selects');

    if (!variantSelects) return '';

    const colorSelect =
      variantSelects.querySelector(
        'select[name="options[Color]"], select[name="options[Colour]"]'
      );

    if (colorSelect) {
      return colorSelect.value;
    }

    /*
     * FALLBACK FOR RADIO-BASED VARIANT SELECTORS
     */
    const checkedInput =
      variantSelects.querySelector(
        'input[type="radio"]:checked'
      );

    if (checkedInput) {
      const fieldset =
        checkedInput.closest('fieldset');

      const legend =
        fieldset?.querySelector('legend');

      const optionName =
        normalize(legend?.textContent);

      if (
        optionName === 'color' ||
        optionName === 'colour'
      ) {
        return checkedInput.value;
      }
    }

    return '';
  }

  /*
   * HANDLE VARIANT CHANGE
   */
  function handleVariantChange(productInfo) {
    const color =
      getSelectedColor(productInfo);

    if (!color) return;

    const gallery =
      getGallery(productInfo);

    if (!gallery) return;

    filterGallery(color, gallery);
  }

  /*
   * NORMAL VARIANT SELECT CHANGE
   */
  document.addEventListener(
    'change',
    function (event) {
      const target = event.target;

      if (
        !target.matches(
          'variant-selects select, variant-selects input[type="radio"]'
        )
      ) {
        return;
      }

      const productInfo =
        target.closest('product-info') ||
        document.querySelector('product-info');

      if (!productInfo) return;

      /*
       * WAIT UNTIL SHOPIFY UPDATES THE VARIANT
       */
      setTimeout(function () {
        handleVariantChange(productInfo);
      }, 50);
    }
  );

  /*
   * SHOPIFY VARIANT CHANGE EVENT
   */
  document.addEventListener(
    'variant:change',
    function (event) {
      const productInfo =
        event.target?.closest('product-info') ||
        document.querySelector('product-info');

      if (!productInfo) return;

      const variant =
        event.detail?.variant;

      if (!variant) {
        handleVariantChange(productInfo);
        return;
      }

      const gallery =
        getGallery(productInfo);

      if (!gallery) return;

      /*
       * COLOR IS USUALLY OPTION1.
       * USE THE SELECTED COLOR INPUT FIRST.
       */
      let color = '';

      const colorInput =
        productInfo.querySelector(
          'select[name="options[Color]"], ' +
          'select[name="options[Colour]"], ' +
          'input[type="radio"][name="Color"]:checked, ' +
          'input[type="radio"][name="Colour"]:checked'
        );

      if (colorInput) {
        color = colorInput.value;
      }

      /*
       * FALLBACK TO VARIANT OPTION1
       */
      if (!color && variant.option1) {
        color = variant.option1;
      }

      if (color) {
        filterGallery(color, gallery);
      }
    }
  );

 
})();